// extracted by mini-css-extract-plugin
export default {"container":"CoreAbilities_container__kCZij box_box__L7O9A","heading":"CoreAbilities_heading__WTGRs heading_heading1__5c8hq heading_heading__UU6lL"};